import { AxiosHttpServiceBuilder } from '@wallbox/http'
import { wapiStripeRepositoryBuilder } from './WapiRepository'

export const wapiStripeRepository = () => wapiStripeRepositoryBuilder({
  httpService: new AxiosHttpServiceBuilder()
})
